import React from 'react';
import { EdgeWrapper } from './Edge.styles';
import { Shimmer } from '../../../../../../../../../../CommonComponents/OPL/Shimmer/Shimmer';

export const EdgeLoading = () => {
  return (
    <EdgeWrapper>
      <Shimmer width="100px" height={20} mx="auto" mt="8" />
    </EdgeWrapper>
  );
};
